import PackagesStep from '@screens/configuration/packages'

export default function PackagesStepPage() {
  return <PackagesStep />
}
